import { render } from "./myTask.vue?vue&type=template&id=fb3bb5e6"
import script from "./myTask.vue?vue&type=script&lang=js"
export * from "./myTask.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__